import { __read } from 'tslib';
import invert from '../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/invert.js';

var useMappingOptions = function (record) {
    if (record === void 0) { record = {}; }
    var mapping = invert(record);
    var options = Object.entries(record).map(function (_a) {
        var _b = __read(_a, 2), label = _b[0], value = _b[1];
        return ({
            label: label,
            value: value,
        });
    });
    return {
        mapping: mapping,
        options: options,
        origin: record,
    };
};

export { useMappingOptions as default };
